import { render, staticRenderFns } from "./SearchHeader.vue?vue&type=template&id=51d4893f&scoped=true&"
import script from "./SearchHeader.vue?vue&type=script&lang=js&"
export * from "./SearchHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d4893f",
  null
  
)

export default component.exports